import React, { useState, useEffect } from "react";

function HtmlViewer({ htmlFilePath }) {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (htmlFilePath) {
      setLoading(true);
      setError(null);
      setTimeout(async () => {
        await fetch(htmlFilePath)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((data) => {
            setHtmlContent(data);
            setLoading(false);
          })
          .catch((err) => {
            console.error("Error fetching HTML:", err);
            setError(
              "Failed to load HTML content. Please check permissions or network."
            );
            setLoading(false);
          });
      }, 5000)
    } else {
      setHtmlContent("");
      setLoading(false);
    }
  }, [htmlFilePath]);

  if (loading) return <div>Loading HTML...</div>;
  if (error) return <div style={{ color: "red" }}>Error: {error}</div>;
  if (!htmlContent) return <div>No HTML content to display.</div>;

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}
export default HtmlViewer
